import { call, put, select } from 'redux-saga/effects';
import { types as integrationTypes } from '@reducers/accountIntegrations';
import * as Api from '@utils/Api';
import { setDestIfNeeded } from '@utils/intendedDest';
import { pathnameSelector } from '../selectors/Router';
import { navigate } from '../reducers/Navigation';

export function* fetchIntegrations() {
  const response = yield call(Api.get, 'account/integrations');
  const pathname = yield select(pathnameSelector);
  if (!response.success) {
    yield put({
      type: integrationTypes.INTEGRATIONS_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
    });

    if (
      response.status === 403 &&
      response.data.error_type &&
      response.data.error_type === 'UserNotAcceptedTermsException' &&
      !pathname.startsWith('/complete_profile')
    ) {
      yield call(setDestIfNeeded);
      yield put(navigate({ href: '/complete_profile' }));
    }
  } else {
    yield put({
      type: integrationTypes.INTEGRATIONS_SUCCESS,
      integrations: response.data,
    });
  }
}
